import React from 'react';
import {
  LineChart,
  Line,
  AreaChart,
  Area,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Legend,
} from 'recharts';

export const SessionsChart = ({ data }) => {
  return (
    <ResponsiveContainer width="100%" height={300}>
      <AreaChart data={data}>
        <defs>
          <linearGradient id="colorSessions" x1="0" y1="0" x2="0" y2="1">
            <stop offset="5%" stopColor="#E63946" stopOpacity={0.3} />
            <stop offset="95%" stopColor="#E63946" stopOpacity={0} />
          </linearGradient>
        </defs>
        <CartesianGrid strokeDasharray="3 3" stroke="#E7E5E4" />
        <XAxis dataKey="month" stroke="#78716C" fontSize={12} />
        <YAxis stroke="#78716C" fontSize={12} />
        <Tooltip
          contentStyle={{
            backgroundColor: 'white',
            border: '1px solid #E7E5E4',
            borderRadius: '8px',
          }}
        />
        <Area
          type="monotone"
          dataKey="sessions"
          stroke="#E63946"
          strokeWidth={2}
          fill="url(#colorSessions)"
        />
      </AreaChart>
    </ResponsiveContainer>
  );
};

export const ReferralFunnelChart = ({ data }) => {
  return (
    <ResponsiveContainer width="100%" height={300}>
      <BarChart data={data}>
        <CartesianGrid strokeDasharray="3 3" stroke="#E7E5E4" />
        <XAxis dataKey="status" stroke="#78716C" fontSize={12} />
        <YAxis stroke="#78716C" fontSize={12} />
        <Tooltip
          contentStyle={{
            backgroundColor: 'white',
            border: '1px solid #E7E5E4',
            borderRadius: '8px',
          }}
        />
        <Bar dataKey="count" fill="#E63946" radius={[8, 8, 0, 0]} />
      </BarChart>
    </ResponsiveContainer>
  );
};

export const PointsChart = ({ data }) => {
  return (
    <ResponsiveContainer width="100%" height={300}>
      <LineChart data={data}>
        <CartesianGrid strokeDasharray="3 3" stroke="#E7E5E4" />
        <XAxis dataKey="month" stroke="#78716C" fontSize={12} />
        <YAxis stroke="#78716C" fontSize={12} />
        <Tooltip
          contentStyle={{
            backgroundColor: 'white',
            border: '1px solid #E7E5E4',
            borderRadius: '8px',
          }}
        />
        <Legend />
        <Line
          type="monotone"
          dataKey="issued"
          stroke="#3B82F6"
          strokeWidth={2}
          name="Points Issued"
        />
        <Line
          type="monotone"
          dataKey="redeemed"
          stroke="#10B981"
          strokeWidth={2}
          name="Points Redeemed"
        />
      </LineChart>
    </ResponsiveContainer>
  );
};